import { I18n } from '@calendly/i18n'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import { SimplePopup } from '@calendly/ui/components/popup'
import { RadioInput } from '@calendly/ui/components/radio-input'
import { BodyText } from '@calendly/ui/components/typography'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { DomainControlNotice } from '../domain_control_notice'
import { isRemovePopupOpenSelector, selectedMembershipsSelector, isRemovingLoadingSelector } from '../selectors'
import {
  closeRemoveUserPopup,
  batchDeleteUsersAndCloseModal,
  batchRemoveUsersAndCloseModal
} from '../slice'
import { Wrapper, RemovalOption, Label, LabelText, Description, RemovalOptionWrapper } from './shared'


export const RemoveSelectedUsers = () => {
  const dispatch = useDispatch()

  const selectedMemberships = useSelector(selectedMembershipsSelector)
  const isOpen = useSelector(isRemovePopupOpenSelector)
  const isRemovingLoading = useSelector(isRemovingLoadingSelector)
  const [willDelete, setWillDelete] = useState(false)
  const [action, setAction] = useState('remove')

  const canDelete = selectedMemberships.every((user) => user.policy.delete_user)

  const handleActionChanged = (event) => {
    setAction(event.target.value)
    setWillDelete(event.target.value === 'delete')
  }

  const handleClose = () => { dispatch(closeRemoveUserPopup()) }
  const handleSubmit = willDelete
    ? () => dispatch(batchDeleteUsersAndCloseModal())
    : () => dispatch(batchRemoveUsersAndCloseModal())

  const confirmLabel = willDelete
    ? I18n.t('publisher.organization.members.batch_remove.remove_and_delete_button') : I18n.t('publisher.action.remove')

  return (
    <SimplePopup
      isOpen={isOpen}
      title={I18n.t('publisher.organization.members.batch_remove.title')}
      onClose={handleClose}
      cancelLabel={I18n.t('publisher.action.cancel')}
      onConfirm={handleSubmit}
      isLoading={isRemovingLoading}
      confirmLabel={confirmLabel}
    >
      <Wrapper>
        <BodyText weight="bold">
          {I18n.t('publisher.organization.members.selected_members_count', { count: selectedMemberships.length })}
        </BodyText>
        <RemovalOptionWrapper>
          <RemovalOption>
            <Label htmlFor="remove-user">
              <RadioInput id="remove-user" name="action" value="remove" checked={action === 'remove'} onChange={handleActionChanged} />
              <LabelText>{I18n.t('publisher.organization.members.batch_remove.remove')}</LabelText>
            </Label>
            <Description>
              {I18n.t('publisher.organization.members.batch_remove.remove_explanation')}
            </Description>
          </RemovalOption>

          <RemovalOption disabled={!canDelete}>
            <Label htmlFor="delete-user">
              <RadioInput
                id="delete-user"
                name="action"
                value="delete"
                checked={action === 'delete'}
                onChange={handleActionChanged}
                disabled={!canDelete}
              />
              <LabelText>{I18n.t('publisher.organization.members.batch_remove.remove_and_delete')}</LabelText>
            </Label>
            <Description>
              {I18n.t('publisher.organization.members.batch_remove.remove_and_delete_explanation')}
            </Description>
          </RemovalOption>
        </RemovalOptionWrapper>
        {!canDelete && (
        <ContextualBanner>
          {I18n.t('publisher.organization.members.batch_remove.can_not_delete_explanation')}
        </ContextualBanner>
        )}
      </Wrapper>
      <DomainControlNotice memberships={selectedMemberships} remove />
    </SimplePopup>
  )
}
